import CloseSharp from "@mui/icons-material/CloseSharp";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import GeneralSkeleton from "@/components/skeleton/general-skeleton";

const PreviewSkeleton = ({
  onClose,
  hideCloseBtn = false,
  hideBottomBtn = false,
  minHeight = "calc(100vh - 2px)",
  presentationStyles = { width: 400, padding: 3 },
  isAppointmentOnly = false,
}) => {
  return (
    <Box className="custom-scroll" sx={{ overflow: "auto" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          minHeight: minHeight,
        }}
      >
        <Box sx={presentationStyles} role="presentation">
          {!hideCloseBtn && (
            <IconButton
              onClick={() => onClose()}
              style={{ position: "absolute", right: "10px" }}
            >
              <CloseSharp />
            </IconButton>
          )}
          <Box>
            <Box sx={{ my: 2 }}>
              <UserInfoSkeleton />
            </Box>
            
            {isAppointmentOnly ? (
              <>
                <Box sx={{ mt: 4 }}>
                  <Stack spacing={3}>
                    {[...Array(3)].map((_, index) => (
                      <GeneralSkeleton
                        key={index}
                        variant="rounded"
                        width={"100%"}
                        height={30}
                      />
                    ))}
                  </Stack>
                </Box>
                <Box sx={{ mt: 4 }}>
                  <Stack spacing={2}>
                    {[...Array(4)].map((_, index) => (
                      <GeneralSkeleton
                        key={index}
                        variant="rounded"
                        width={"80%"}
                        height={20}
                      />
                    ))}
                  </Stack>
                </Box>
              </>
            ) : (
              <>
                <GeneralSkeleton variant="rounded" height={40} />

                <Box sx={{ pt: 2 }}>
                  <GeneralSkeleton height={30} />
                </Box>
                <Box sx={{ mt: 2, mb: 2 }}>
                  <GeneralSkeleton
                    variant="rounded"
                    height={20}
                    width={200}
                    sx={{ margin: "0 auto" }}
                  />
                </Box>
                <Box>
                  <Stack spacing={3}>
                    {[...Array(6)].map((_, index) => (
                      <GeneralSkeleton
                        key={index}
                        variant="rounded"
                        width={"100%"}
                        height={40}
                      />
                    ))}
                  </Stack>
                </Box>
              </>
            )}
          </Box>
        </Box>
        {!hideBottomBtn && (
          <Grid container style={{ position: "relative", bottom: 0 }}>
            <GeneralSkeleton variant="rounded" width={"100%"} height={40} />
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default PreviewSkeleton;

const UserInfoSkeleton = () => (
  <Grid container alignItems="center" columnSpacing={{ xs: 2 }}>
    <Grid item>
      <GeneralSkeleton variant="circular" width={55} height={55} />
    </Grid>
    <Grid item xs>
      <GeneralSkeleton height={30} width={150} />
      <GeneralSkeleton width={220} />
    </Grid>
  </Grid>
);
